"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./AnimatedSpinner.scss");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AnimatedSpinner =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AnimatedSpinner, _React$Component);

  function AnimatedSpinner() {
    _classCallCheck(this, AnimatedSpinner);

    return _possibleConstructorReturn(this, _getPrototypeOf(AnimatedSpinner).apply(this, arguments));
  }

  _createClass(AnimatedSpinner, [{
    key: "render",
    value: function render() {
      var className = 'c-AnimatedSpinner';
      var _this$props = this.props,
          padding = _this$props.padding,
          xAndYCordinates = _this$props.xAndYCordinates,
          fill = _this$props.fill;
      return _react2.default.createElement("div", {
        className: "c-AnimatedSpinner__componentContainer"
      }, _react2.default.createElement("div", {
        style: {
          paddingTop: padding
        }
      }, _react2.default.createElement("div", {
        className: "".concat(className, "__success-checkmark2")
      }, _react2.default.createElement("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 135.3 135.4",
        width: "92px",
        height: "92px"
      }, _react2.default.createElement("g", null, _react2.default.createElement("circle", _extends({}, xAndYCordinates, {
        fill: fill.fill1
      })), _react2.default.createElement("circle", _extends({}, xAndYCordinates, {
        fill: fill.fill2,
        transform: "rotate(45,64,64)"
      })), _react2.default.createElement("circle", _extends({}, xAndYCordinates, {
        fill: fill.fill3,
        transform: "rotate(90,64,64)"
      })), _react2.default.createElement("circle", _extends({}, xAndYCordinates, {
        fill: fill.fill4,
        transform: "rotate(135,64,64)"
      })), _react2.default.createElement("circle", _extends({}, xAndYCordinates, {
        fill: fill.fill5,
        transform: "rotate(180,64,64)"
      })), _react2.default.createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        values: "45 64 64;90 64 64;135 64 64;180 64 64;225 64 64;270 64 64;315 64 64,0 64 64",
        calcMode: "discrete",
        dur: "960ms",
        repeatCount: "indefinite"
      }))))));
    }
  }]);

  return AnimatedSpinner;
}(_react2.default.Component);

AnimatedSpinner.defaultProps = {
  padding: '0%',
  xAndYCordinates: {
    cx: 8,
    cy: 48,
    r: 8
  },
  fill: {
    fill1: "#dfcddf",
    fill2: "#dfcddf",
    fill3: "#bc96bc",
    fill4: "#955895",
    fill5: "#600460"
  }
};
exports.default = AnimatedSpinner;